/**
 * Local storage for DSOK Daily Menu Screen settings. Key: dsok.dailyMenu.screenSettings.v1
 * Jedno nastavenie pre oba typy obrazovky (landscape aj portrait).
 */
import defaultSeed from "app/data/dailyMenuScreenSettings.demo.js";

const STORAGE_KEY = "dsok.dailyMenu.screenSettings.v1";

function getStoredData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        if (parsed.settings) return parsed;
        // Migrácia zo starého formátu (menus[menuId].landscape/portrait)
        if (parsed.menus && typeof parsed.menus === "object") {
          const firstMenuId = Object.keys(parsed.menus)[0];
          const menu = firstMenuId && parsed.menus[firstMenuId];
          const single = menu?.landscape || menu?.portrait;
          if (single) return { settings: { ...defaultSeed, ...single } };
        }
      }
    }
  } catch (e) {
    console.warn("dailyMenuScreenSettings storage read failed", e);
  }
  return { settings: { ...defaultSeed } };
}

function normalizeToSeconds(settings) {
  const out = { ...settings };
  if (out.languageRotationIntervalMs != null && out.languageRotationIntervalSec == null) {
    out.languageRotationIntervalSec = Math.max(1, Math.round(Number(out.languageRotationIntervalMs) / 1000));
    delete out.languageRotationIntervalMs;
  }
  if (out.pageRotationIntervalMs != null && out.pageRotationIntervalSec == null) {
    out.pageRotationIntervalSec = Math.max(1, Math.round(Number(out.pageRotationIntervalMs) / 1000));
    delete out.pageRotationIntervalMs;
  }
  if (out.maxMealsPerPage != null && (out.maxMealsPerPageLandscape == null || out.maxMealsPerPagePortrait == null)) {
    const val = Math.max(1, Number(out.maxMealsPerPage) || 5);
    if (out.maxMealsPerPageLandscape == null) out.maxMealsPerPageLandscape = val;
    if (out.maxMealsPerPagePortrait == null) out.maxMealsPerPagePortrait = val;
    delete out.maxMealsPerPage;
  }
  if (
    out.productDisplayType != null &&
    (out.productDisplayTypeLandscape == null || out.productDisplayTypePortrait == null)
  ) {
    const val = out.productDisplayType === "grid" ? "grid" : "list";
    if (out.productDisplayTypeLandscape == null) out.productDisplayTypeLandscape = val;
    if (out.productDisplayTypePortrait == null) out.productDisplayTypePortrait = val;
    delete out.productDisplayType;
  }
  return out;
}

export function getSettings() {
  const data = getStoredData();
  const merged = { ...defaultSeed, ...data.settings };
  return normalizeToSeconds(merged);
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ settings: { ...settings } }));
    return true;
  } catch (e) {
    console.warn("dailyMenuScreenSettings storage write failed", e);
    return false;
  }
}
